import React, {useEffect} from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import ItemBanner from "../ItemBanner";

const Banner = () => {
    const [showArticles, setShowArticles] = React.useState(false);
    const [articulosBanner, setArticulosBanner] = React.useState(null);

    const verArticulosSlide = () => {
        setShowArticles(!showArticles);
    }

    

    useEffect(() => {    
        const agregarArticulosBanner = (artsBanner) => {
            setArticulosBanner(artsBanner.sort(()=> Math.random() - 0.5));
        }

        const articulosBannerTemp = [
            {
                name: "Mens parka jacket Urban, quantum grau",
                id: "802",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/b21d94e6-ec95-467f-b4df-c13e4d8fa55e.jpg"
            },{
                name: "Mens winter jacket, red",
                id: "803",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/4617aa27-6672-4478-8846-c9724b86cee8.jpg"
            },{
                name: "Mens poloshirt, white",
                id: "80e",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/367170a3-3f4e-40f2-baab-c03011514408.jpg"
            },{
                name: "Audi shirt Mens white",
                id: "946",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/bef22455-a8b8-4193-8fcb-11da44d082cb.jpg"
            },{
                name: "Audi Tie, Mens, grey",
                id: "81e",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/ee21c48f-44e3-47e2-bc4b-33e14d967784.jpg"
            },{
                name: "Audi Tie, Mens, red",
                id: "81c",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/ff950ed4-1989-4194-ad7a-68eefa9f8549.jpg"
            },{
                name: "Audi Tie, Mens, blue",
                id: "81d",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/83370737-8d70-48da-97e3-5440260d753f.jpg"
            },{
                name: "Mens lightweight jacket, Audi Sport",
                id: "7d1",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/929e6697-0399-4c71-8213-f61477b46316.jpg"
            },{
                name: "Audi R8 Spyder V10, Suzuka grey",
                id: "91a",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/aa681d20-75da-48f9-a406-bab8e0c5334d.jpg"
            },{
                name: "Audi R8 Spyder, Dynamite Red",
                id: "918",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/e2e15ab2-9027-49e7-82a4-72edd5203fbb.jpg"
            },{
                name: "Audi Keyring leather e-tron",
                id: "961",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/ba55752f-0706-4c77-bd06-d3859cdba207.jpg"
            },{
                name: "Audi Keyring KeyFinder, black",
                id: "84f",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/feb74d6f-257e-47c4-9767-184d2dbb26e8.jpg"
            },{
                name: "Audi mug red",
                id: "86a",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/60b92d5a-b80f-4bb8-aa23-f093e5b72a15.jpg"
            },{
                name: "Audi mug A1 Azul",
                id: "996",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/1bc8e3db-fd30-48b0-9561-4de0aca1b5c0.jpg"
            },{
                name: "Audi mug A1 Naranja",
                id: "997",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/4c1006cc-3bae-470d-87c3-08b96a749e59.jpg"
            },{
                name: "quattro flip flop, grey",
                id: "7f9",
                image: "https://www.appsaudi.com.mx/resources/images/boutique/6ff24fff-40d8-4320-b25b-b0598345b49a.jpg"
            }
        ];
        agregarArticulosBanner(articulosBannerTemp);
    }, []);

    return (
        <div className="banner">
            <div className={ !showArticles ? "banner__info active" : "banner__info banner__slide" }>
                <div className="banner__info--image d-block d-sm-none col-md-7 col-lg-8">
                    <LazyLoadImage
                        alt="banner01"
                        src="https://www.appsaudi.com.mx/resources/images/boutique/banner/Banner_Movil.jpg"
                    />
                </div>
                <div className="banner__info--image d-none d-sm-block col-md-7 col-lg-8">
                    <LazyLoadImage
                        alt="banner01"
                        src="https://www.appsaudi.com.mx/resources/images/boutique/banner/Banner_Desktop.jpg"
                    />
                </div>
                <div className="banner__info--detail col-md-5 col-lg-4">
                    <h3>Artículos de</h3>
                    <span>Temporada</span>
                    <p>Viajar con papá equivale a kilómetros de diversión.</p>
                    <button onClick={() => verArticulosSlide()}>Ver</button>
                </div>
            </div>
            <div className={ showArticles ? "banner__articles active" : "banner__articles banner__slide" }>
                <div className="banner__articles--detail">
                    <h3>Artículos de</h3>
                    <span>Temporada</span>

                    <button className="btn-general btn-tertiary-prev v-align-c" onClick={() => verArticulosSlide()}>
                        <svg className="i-rotate" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <path id="arrow_right" d="M10.735,16.028,12,17.293l6-6-6-6L10.735,6.558l3.84,3.84H6v1.789h8.576Z" transform="translate(-6 -5.293)" fill="#fff"/>
                        </svg>
                        <span>Volver</span>
                    </button>
                </div>
                <div className="banner__articles--all">
                    <div className="d-block container_item">
                        {
                            articulosBanner !== null &&
                            <>
                                <ItemBanner 
                                    name={articulosBanner[0].name}
                                    idArticulo={articulosBanner[0].id}
                                    imagen={articulosBanner[0].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[1].name}
                                    idArticulo={articulosBanner[1].id}
                                    imagen={articulosBanner[1].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[2].name}
                                    idArticulo={articulosBanner[2].id}
                                    imagen={articulosBanner[2].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[3].name}
                                    idArticulo={articulosBanner[3].id}
                                    imagen={articulosBanner[3].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[4].name}
                                    idArticulo={articulosBanner[4].id}
                                    imagen={articulosBanner[4].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[5].name}
                                    idArticulo={articulosBanner[5].id}
                                    imagen={articulosBanner[5].image}
                                />
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;